export const checkSchema = (item: any) => {
    if (item.schema && item.schema.properties && (Object.keys(item.schema).length !== 0 && Object.keys(item.schema.properties).length !== 0)) {
        return true;
    }
    return false;
}